<div class="container-fluid">
  <div class="row">
    <div class="d-none d-xl-flex col-xl-5 login-two">
      <div class="login-tittle">
        <h2>{{tituloLogin}}</h2>
        <p>{{textoLogin}}</p>
      </div>
    </div>
    <div class="col-xl-7 p-0">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" routerLink='/'>
              <!-- <img class="img-fluid for-light" src="assets/images/logo/login.png" alt="looginpage">
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage"> -->
              <h1>{{config.cliente!.titulo_page}}</h1>
            </a>

          </div>
          <!-- SC CATWEB-332 Formulario para login de usuario -->
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>Iniciar Sesión</h4>
              <p>{{config.cliente!.titulo_login}}</p>
              <div class="form-group">
                <label class="col-form-label">Usuario</label>
                <input class="form-control" type="text" required="" placeholder="Usuario" formControlName="usuario" list="usuariosRecordados">
                <!-- MV CATWEB-322 Datalist con usuarios guardados -->
                <datalist id="usuariosRecordados">
                  <option *ngFor="let usuario of usuariosGuardados" [value]="usuario">
                </datalist>
                  <div *ngIf="loginForm.controls.usuario.touched && loginForm.controls.usuario.errors?.required"
                      class="text text-danger mt-1">
                      Usuario es requerido
                  </div>
                  <div *ngIf="loginForm.controls.usuario.touched && loginForm.controls.usuario.errors?.usuario"
                      class="text text-danger mt-1">
                      Usuario no valido
                  </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Contraseña</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required="" placeholder="*********">
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><i class="fa fa-eye-slash"></i></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><i class="fa fa-eye"></i></div>
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required"
                      class="text text-danger mt-1">
                      Contraseña es requerida
                </div>
              </div>
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox" formControlName="recordarme">
                  <label class="text-muted" for="checkbox1">Recordarme</label>
                </div>
                <!-- SC CATWEB-332 Link a recuperar contraseña -->
                <a [routerLink]="'/authentication/forgot-password'" class="link">Olvidé mi contraseña</a>

                <button class="btn btn-primary btn-block"
                  [class.loader--text]="authService.showLoader"
                  [disabled]="!loginForm.valid || authService.showLoader"
                  (click)="login()"
                  type="submit"><span>{{ authService.showLoader ? '' : 'Ingresar' }}</span>
                </button>

              </div>
              <ng-container *ngIf="config.sesion.invitado.active">
                <div class="social mt-2">
                  <div class="btn btn-block btn-showcase">
                    <a class="btn btn-light" (click)="loginInvitado()">
                        <app-feather-icons [icon]="'user'" class="txt-fb"></app-feather-icons>Ingresar como Invitado
                    </a>
                  </div>
                </div>
              </ng-container>


              <p class="mt-4 mb-0" *ngIf="false">
                <!-- SC CATWEB-332 Link Crear cuenta de usuario para clientes registrados en sinergial -->
                <a [routerLink]="'/authentication/register/simple'" class="ml-2">Registro para Clientes</a>
              </p>

            </form>
          </div>
          <!-- SC CATWEB-332 Formulario End. -->
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Copyright © 2019-{{ today | date:'y'}} <a href="https://www.oliverinformatica.com/"
          target="_blank"> Oliver</a> - Versión: {{version}}</p>
    </div>
  </div>
</div>
<app-customizer></app-customizer>
